module.exports = __webpack_public_path__ + "media/promo/panasonic/images/hero-77da74470b08282846bb12c5142e7ed7.jpg";